import { render, staticRenderFns } from "./ListTransaksi.vue?vue&type=template&id=a59f9ce2"
import script from "./ListTransaksi.vue?vue&type=script&lang=js"
export * from "./ListTransaksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports